export const list = {
  REQUEST: 'Activity/List/Request',
  SUCCESS: 'Activity/List/Success',
  FAILURE: 'Activity/List/Failure'
};

export const GET = {
  REQUEST: 'Activity/GET/Request',
  SUCCESS: 'Activity/GET/Success',
  FAILURE: 'Activity/GET/Failure'
};

export const CREATE = {
  REQUEST: 'Activity/CREATE/Request',
  SUCCESS: 'Activity/CREATE/Success',
  FAILURE: 'Activity/CREATE/Failure'
};

export const UPDATE = {
  REQUEST: 'Activity/UPDATE/Request',
  SUCCESS: 'Activity/UPDATE/Success',
  FAILURE: 'Activity/UPDATE/Failure'
};

export const DELETE = {
  REQUEST: 'Activity/DELETE/Request',
  SUCCESS: 'Activity/DELETE/Success',
  FAILURE: 'Activity/DELETE/Failure'
};

export const CLEAR = {
  SUCCESS: 'Activity/CLEAR/Success'
};
